import React from 'react';
import styled from 'styled-components';
import Tooltip from '@mui/material/Tooltip';
import Fab from '@mui/material/Fab';
import Dialpad from '@mui/icons-material/Dialpad';
import Phone from '@mui/icons-material/Phone';
import Reply from '@mui/icons-material/Reply';
import { Link } from 'react-router-dom';
import { withTranslation } from 'react-i18next';

import colors from '../../main/themes/colors';

const StyledDialpad = styled(Fab)`
  && {
    color: ${colors.white};
    background-color: ${colors.secondary};
    width: 60px;
    height: 60px;

    &:hover {
      background-color: ${colors.hovered};
    }
  }
`;

const StyledCall = styled(Fab)`
  && {
    color: ${colors.white};
    background-color: ${({ red }) => (!!red ? colors.redButton : colors.greenButton)};
    width: 60px;
    height: 60px;

    &:hover {
      background-color: ${({ red }) => (!!red ? colors.redButtonHover : colors.greenButtonHover)};
    }

    & svg {
      transform: ${({ red, call }) => (red ? 'rotate(135deg)' : call ? 'rotate(135deg)' : 'none')};
    }
  }
`;

export const DialpadButton = () => (
  <Link to="/dialer">
    <StyledDialpad>
      <Dialpad />
    </StyledDialpad>
  </Link>
);

export const CallButton = ({ disabled = false, action }) => (
  <StyledCall disabled={disabled} id="answer" onClick={action}>
    <Phone />
  </StyledCall>
);

export const HangupButton = ({ action }) => (
  <StyledCall id="endCallButton" onClick={action} red={1}>
    <Phone />
  </StyledCall>
);

export const ReturnToCall = withTranslation('dialer')(({ t }) => (
  <Link id="return-to-call" to="/call">
    <Tooltip placement="top" title={t('returnToCall')}>
      <StyledCall call={1}>
        <Reply />
      </StyledCall>
    </Tooltip>
  </Link>
));
